import React from "react";
import { useTranslation } from "react-i18next";

const items = [
    ['#dc2626', 'not_usable'],
    ['#f59e0b', 'need_attention'],
    ['#16a34a', 'available'],
    ['#2563eb', 'in_use'],
    ['#6b7280', 'unknown_status'],
];

const MapStatusLegend: React.FC = () => {
    const { i18n } = useTranslation();
    const t = (key: string, options?: object) => (i18n.t as unknown as (key: string, options?: object) => string)(key, options);

    return (
        <div className="map-status-legend">
            {items.map(([color, label]) => (
                <span key={label}><i style={{ backgroundColor: color }} />{t(`track_trace.legend.${label}`)}</span>
            ))}
        </div>
    );
};

export default MapStatusLegend;
